<delete-form
  [width]="width || '500px'"
  [title]="title || 'Are you sure?'"
  [load]="load"
  [submitting]="submitting"
  [submitText]="submitText || 'Yes'"
  (close)="close.emit()"
  [disableDelete]="!confirmed"
  (submitted)="submitted.next(undefined)"
>
  <div class="rv-grid-large">
    <div class="grid-inner">
      <div class="column-small-12">
        {{ mainText || "Select 'Yes' to proceed" }}
      </div>
      <ng-container *ngIf="showAlternateSubmitLogic"
        ><riv-checkbox
          [value]="alternateSubmitLogicValue"
          (valueChange)="
            changeAlternateSubmitLogicValue($event);
            alternateSubmitLogicValueChange.emit($event)
          "
          >{{ alternateSubmitLogicText }}</riv-checkbox
        ></ng-container
      >
      <div *ngIf="submitConfirmationText" class="column-small-12">
        <deprecated-text-field
          [label]="submitConfirmationMessage"
          [placeholder]="submitConfirmationText"
          [ngModel]="confirmationText"
          (ngModelChange)="checkConfirmation($event)"
        >
        </deprecated-text-field>
      </div>
    </div>
  </div>
</delete-form>
